"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindowWidth = void 0;
var react_1 = require("react");
function useWindowWidth() {
    var _a = (0, react_1.useState)(0), width = _a[0], setWidth = _a[1];
    (0, react_1.useEffect)(function () {
        function update() {
            setWidth(window.innerWidth);
        }
        window.addEventListener("resize", update);
        update();
        return (function () { return window.removeEventListener("resize", update); });
    }, []);
    return width;
}
exports.useWindowWidth = useWindowWidth;
//# sourceMappingURL=layout-utils.js.map